(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("leaflet"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueChoropleth", ["leaflet", "vue"], factory);
	else if(typeof exports === 'object')
		exports["VueChoropleth"] = factory(require("leaflet"), require("vue"));
	else
		root["VueChoropleth"] = factory(root["L"], root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_47__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition